module.exports = __webpack_public_path__ + "static/img/popup-swiper1.56d3ff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-swiper1.png
// module id = csoD
// module chunks = 0